@if (_currentData.renderView) {
  @if (_layout == 'tab' && _currentData.tabType == 'vertical') {
    <div class="backNavigationViewer layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}} _main-container"
      >
      <div #sideBarMenuRef
        [ngClass]=" _layout_data[_layout_id] != undefined && _layout_data[_layout_id]['data']['closeSideBar'] != undefined && _layout_data[_layout_id]['data']['closeSideBar'] ? '_main-container sidebar-mini-new' : '_main-container'">
        <div class="_sidebar-menu-container">
          <div class="_sidebar-menu">
            @if (_layout_data) {
              <div class="">
                @for (layout_key of _layout_data | keys; track layout_key) {
                  @if (_layout_data[layout_key]['data']['permission_required'] ? rolePermissionService.checkAccessPermission(_layout_data[layout_key]['data']['action_name'], _layout_data[layout_key]['data']['resource']) : true) {
                    @if (_layout_data[layout_key]['data']['visible'] || _layout_data[layout_key]['data']['visible'] == undefined) {
                      <div class="_wf-emr-element-indiv"
                        [ngClass]="layout_key == _layout_id ? 'active show' : ''" id="{{layout_key}}"
                        (click)="activeTab(layout_key)">
                        <div class="_wf-emr-icondiv">
                          <div class="_wf-sidebar-icon">
                            <img [src]="'assets/images/'+(_layout_data[layout_key]['data'].icon_name ? _layout_data[layout_key]['data'].icon_name:'file_icon.svg')"
                              alt="" class="nav-icon nav-img-icon">
                          </div>
                        </div>
                        <div class="_wf-emr-textforcompnpnet">
                          <div class="text-block-73">{{_layout_data[layout_key]['data']['layoutName'] |
                          translate | async }}</div>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            }
          </div>
          <div class="_wf-emr-element-indiv footer-toggle"
            (click)="sideBarMenuRef.classList.toggle('sidebar-mini-new')">
            <div class="_wf-emr-icondiv">
              <div>
                <i class="fa fa-arrows-h" aria-hidden="true"></i>
              </div>
            </div>
            <div class="_wf-emr-textforcompnpnet">
              <div class="text-block-73">{{'field.label.compress_menu' | translate | async }}</div>
            </div>
          </div>
        </div>
        <div [ngClass]=" _layout_data[_layout_id] != undefined ? '_main-body container_'+parent_id :''">
          @if (_currentData.showBanner) {
            <div class="banner-container">
              @if (_currentData.bannerJson && parent_id != 2) {
                <app-resource-banner
                  [bannerJson]="_currentData.bannerJson" (patientResult)="getBannerData($event)">
                </app-resource-banner>
              }
            </div>
          }
          <div class="billing-content-container">
            <div class="main-container-body container_{{parent_id}} p-0">
              @if (_currentData.currentAction == 'LIST' && _currentData.addAllowed && rolePermissionService.checkAccessPermission('add', _currentData.resource)) {
                <div class="pull-right card-action-link"
                  >
                  <!-- <a href="javascript:void(0)" (click)="addResource(_currentData.addButton)"><span class="fa fa-plus"></span>&nbsp;Add</a> -->
                  <button class="primary-btn" (click)="addResource(_currentData.addButton)">
                    <span>Add</span>
                    <i class="fa fa-plus-square" aria-hidden="true"></i>
                  </button>
                </div>
              }
              <!-- <div class="kx-action-on-card"
              *ngIf="_currentData.addAllowed && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed">
              <ng-container [ngTemplateOutlet]="addRenderer"
                [ngTemplateOutletContext]="{_currentData:_currentData}">
              </ng-container>
            </div> -->
            <div id="v-pills-tabContent">
              @if (this._currentData.render_template && _currentData.tabType == 'vertical') {
                <div class="tab-pane kx-v-tab-pane fade active show" id="_layout_id"
                  >
                  @if (_currentData && _currentData.resouceDef && _currentData.resouceDef.child_tab) {
                    <div
                      >
                      <app-report-data-table [input]="_currentData.resouceDef.child_tab" [parent_id]="1">
                      </app-report-data-table>
                    </div>
                  } @else {
                    <ng-container [ngTemplateOutlet]="layoutRenderer"
                      [ngTemplateOutletContext]="{_currentData:_currentData}">
                    </ng-container>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (_currentData.resouceDef) {
  <div class="main-content-container">
    <div [ngClass]="showGridOnly ? '' : 'main-container-body'">
      <!-- change here due dhs form grid action shows banner two times on the screen please review by saurav deep -->
      @if (_currentData.showBanner && !showGridOnly && _currentData.currentAction != 'FORM_GRID') {
        <div>
          @if (_currentData.bannerJson.component == undefined) {
            <app-resource-banner
            [bannerJson]="_currentData.bannerJson"></app-resource-banner>
          }
        </div>
      }
      @if (_layout == 'simple') {
        <div class="page-title-container d-flex justify-content-end">
          @if (_currentData != undefined && _currentData.currentAction == 'LIST' && _currentData.tabConfig !=undefined &&  _currentData.tabConfig.list_back_navigation === true ? true : false) {
            <div class="page-title flex-grow-1"
              >
              <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                <img src="assets/images/grid-back.png" />
              </a>
              {{baseService._currentTitle}}
            </div>
          }
          @if (_layout == 'simple' && !showGridOnly) {
            <div class="page-title w-100">
              @if (_currentData.currentAction == 'LIST') {
                <div class="mb-0">
                  @if (_layout_data.config != undefined && _layout_data.config.list_back_navigation === true ? true : false) {
                    <div class="pl-2 pr-2"
                      >
                      <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                        <img src="assets/images/grid-back.png" />
                      </a>
                      {{baseService._currentTitle}}
                    </div>
                  } @else {
                    {{baseService._currentTitle}}
                  }
                </div>
              }
              @if (_currentData.currentAction != 'LIST') {
                <div class="mb-0">
                  <div class="d-flex align-items-center">
                    @if (_layout_data.config != undefined && _layout_data.config.back_navigation === false ? false : true) {
                      <div class="pl-2 pr-2"
                        >
                        <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                          <img src="assets/images/grid-back.png" />
                        </a>
                      </div>
                    }
                    <div class="">
                      {{baseService._currentTitle}}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (_layout == 'simple') {
            <div class="component-container" style="width: 100%;">
              <div class="d-flex justify-content-end">
                @if ((_currentData.currentAction == 'LIST' || _currentData.currentAction == 'IMAGE_VIEWER') && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed) {
                  <ng-container [ngTemplateOutlet]="addRenderer"
                    [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                }
                <ng-container [ngTemplateOutlet]="switchRenderer"
                  [ngTemplateOutletContext]="{_currentData:_currentData}">
                </ng-container>
              </div>
            </div>
          }
          <!-- <div class="component-container" *ngIf="_layout == 'simple'">
          <div class="d-flex justify-content-end"
            *ngIf="(_currentData.currentAction == 'LIST' || _currentData.currentAction == 'IMAGE_VIEWER')">
            <ng-container [ngTemplateOutlet]="addRenderer"
              [ngTemplateOutletContext]="{_currentData:_currentData}">
            </ng-container>
            <ng-container [ngTemplateOutlet]="switchRenderer"
              [ngTemplateOutletContext]="{_currentData:_currentData}">
            </ng-container>
          </div>
        </div> -->
      </div>
    }
    @if (_layout == 'simple' && _currentData.render_template) {
      <div class="bg-white main-box-shadow layout_simple layout_simple_{{_currentData.currentResource}}"
        >
        <ng-container [ngTemplateOutlet]="layoutRenderer"
          [ngTemplateOutletContext]="{_currentData:_currentData}">
        </ng-container>
      </div>
    }
    @if (_layout == 'tab') {
      <div class="layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}}"
        >
        @if (_currentData.tabType == 'horizontal' || _currentData.tabType == 'radio') {
          <div class="layout_tab_horizontal layout_tab_horizontal_{{_layout_id}}"
            style="background-color: white;position: relative;">
            <!---action button in case of Tabs : added by abhinav chauhan-->
            <!-- <div class="d-flex justify-content-end" *ngIf="_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed">
            <ng-container [ngTemplateOutlet]="addRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
            </ng-container>
          </div> -->
          <!-- <ul class="nav nav-tabs kx-tabs"> -->
          <ul class="base-tab" id="tab_{{_currentData.json}}" #tabWidth_
            [ngClass]="{'tabWithoutButtons':!(tab_+_currentData.json | getHeight:tabWidth:'tabWidth')}">
            @if ((tab_+_currentData.json | getHeight:tabWidth:'tabWidth') | async) {
              <div class="scroll-btn-move scroll-btn-move-prev"
                >
                <div class="_tab-expand" (click)="toggleTabView($event)">
                  <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  <i class="fa fa-chevron-up" aria-hidden="true"></i>
                </div>
                <div class="tab-prev tab-scroll-actions"
                  (click)="scrolltab('tab_'+_currentData.json,'right')">
                  <div class="tab-prev-circle">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            }
            @for (layout_key of _layout_data | keys; track layout_key) {
              <li class="nav-item">
                <a class="nav-link" [ngClass]="layout_key == _layout_id ? 'active' : ''"
                  (click)="activeTab(layout_key)" data-toggle="tab" id="{{layout_key}}"
                role="tab">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</a>
              </li>
            }
            @if (tab_+_currentData.json | getHeight:tabWidth:'tabWidth') {
              <div class="scroll-btn-move">
                <div class="tab-next tab-scroll-actions">
                  <div class="tab-prev-circle" (click)="scrolltab('tab_'+_currentData.json,'left')">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            }
          </ul>
          @if (this._currentData.render_template) {
            <div class="base-tab-content" id="_layout_id">
              <!---action button in case of Tabs : added by abhinav chauhan-->
              @if (_currentData.currentAction == 'LIST') {
                <div class="d-flex justify-content-end">
                  <ng-container [ngTemplateOutlet]="addRenderer"
                    [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                  <ng-container [ngTemplateOutlet]="switchRenderer"
                    [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                  @if (rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
                    <div class="table-view-toggle tab-settings-button"
                      >
                      <span class="toggle-icn">
                        <i title="{{'cv' | translate | async}}" (click)="configUIEngine({context:'ui'})"
                        class="fa fa-cog"></i>
                      </span>
                    </div>
                  }
                </div>
              }
              <ng-container [ngTemplateOutlet]="layoutRenderer"
                [ngTemplateOutletContext]="{_currentData:_currentData}">
              </ng-container>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
</div>
}
}
<ng-template #switchRenderer let-_currentData='_currentData'>
  <!-- <div (click)="gridPopupApi()" *ngIf="gridPopupValidation && _currentData?.resouceDef?.config?.gridPopupIcon != undefined" class="recent_patient_css">
  <img src="./assets/images/{{_currentData.resouceDef.config.gridPopupIcon}}">
</div> -->
<!-- <div class="table-view-toggle"
*ngIf="_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table  && !utilService.isMobile()">
<span _ngcontent-pbu-c8="" class="toggle-icn">
  <i *ngIf="_currentData.config.activeField == 'table'" class="fa fa-th" (click)="switchView('tile');"></i>
  <i *ngIf="_currentData.config.activeField == 'tile'" class="fa fa-list" (click)="switchView('table');"></i>
</span>
</div> -->
</ng-template>
<ng-template #addRenderer let-_currentData='_currentData'>
  <!--button in case of grid : added by abhinav chauhan-->
  <!-- <ng-container *ngIf="_currentData.addButton == undefined && !showGridOnly"> -->
  <!-- <button class="primary-btn" (click)="downloadAll()">
  <span>{{'button.download_all' | translate | async }}</span>
</button> -->
<!-- </ng-container> -->
<!-- <ng-container *ngIf="_currentData.addButton != undefined && _currentData.addButton.type == 'button'">
<button class="primary-btn" *ngIf="_currentData.showAddButton" (click)="addResource(_currentData.addButton)">
  <span>{{_currentData.addButton.label | translate | async }}</span>
  <i class="fa fa-plus" aria-hidden="true"></i>
</button>
</ng-container> -->

@if (_currentData.addButton != undefined && _currentData.addButton.type == 'button' && !utilService.isMobile()) {
  @if (_currentData.showAddButton) {
    <button class="primary-btn" (click)="addResource(_currentData.addButton)">
      <span>{{_currentData.addButton.label | translate | async }}</span>
      <i class="fa fa-plus" aria-hidden="true"></i>
    </button>
  }
}
@if (_currentData.addButton != undefined && _currentData.addButton.type == 'button' && utilService.isMobile()) {
  @if (_currentData.showAddButton) {
    <button class="mobile-primary-btn"
      (click)="addResource(_currentData.addButton)">
      <i class="fa fa-plus" aria-hidden="true"></i>
      <div>{{_currentData.addButton.label | translate | async }}</div>
    </button>
  }
}
<!-- TO CHECK MIS REPORT ADD BUTTONS -->

@if (_currentData.addButton != undefined && _currentData.addButton.type == 'search') {
  @if (_currentData.showAddButton) {
    <button class="primary-btn mr-2" type="button" (click)="addButtonAction();">
      <span>{{_currentData.addButton.label | translate | async}}</span>
      <i class="fa fa-plus-circle" aria-hidden="true"></i>
    </button>
  }
  @if (!_currentData.showAddButton) {
    <div class="inputSearchElementcontainer" style="z-index:2; position:relative; width:400px;"
      >
      <input-search id="inputSearchElement" [data]="_currentData.addButton" [showAdvSearch]="true"
        [placeholder]="_currentData.addButton.hint" (patientResult)="settingUserInfo($event)"
        (labelEvent)="InputEvent($event);" (closeOverlay)="closesOverlay();">
    </input-search>
  </div>
}
@if (!_currentData.showAddButton) {
  <div class="cstmOverlay"></div>
}
}
</ng-template>
<ng-template #layoutRenderer let-_currentData='_currentData'>
  @if (_currentData.currentAction === 'EDIT_GRID') {
    <div>
      <kx-editable-grid [resourceName]="_currentData.resouceDef.resource"> </kx-editable-grid>
    </div>
  }
  @if (_currentData.currentAction === 'EDITGRID') {
    <div>
      <kx-editable-grid-with-banner [resource]="_currentData.resouceDef.resource">
      </kx-editable-grid-with-banner>
    </div>
  }
  <!-- Form and grid both render -->
  @if (_currentData.currentAction === 'FORM_GRID') {
    <div>
      <dhs-form-grid (bulkActionClicked)="onBulkActionClicked($event)"
        [resourceName]="_currentData.resouceDef.resource" (editEllipseClick)="buttonAction($event)">
      </dhs-form-grid>
    </div>
  }
  @if (_currentData.currentAction === 'IMAGE_VIEWER') {
    <div>
      <app-document-viewer [resourceName]="_currentData.resouceDef.resource"></app-document-viewer>
    </div>
  }
  <!-- <div class="row" *ngIf="_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table">
  <div class="col-12 mb-1 switch-view-container">
    <div class="d-flex mb-1 float-right">
      <button class="switch-view" [ngClass]="_currentData.config.activeField == 'table' ? 'active': ''" *ngIf="_currentData.config.table" (click)="switchView('table');"><i
      class="fa fa-list"></i></button>
      <button class="switch-view" [ngClass]="_currentData.config.activeField == 'tile' ? 'active': ''" *ngIf="_currentData.config.tile" (click)="switchView('tile');"><i class="fa fa-th"></i></button>
    </div>
  </div>
</div> -->

<div class="">
  <!-- {{_currentData.currentFormFields | json}} -->
  @if (_currentData.currentAction === 'ADD') {
    <dhs-form [action]="_currentData.currentAction"
      [data]="_currentData.defaultFormData" [fieldGroup]="_currentData.currentFormFields"
      [config]="_currentData.configForm" [decorator]="_currentData.decorator"
      [customButton]="_currentData.customButton" (saveFinished)="onSaveFinished($event)" #formComponenet>
    </dhs-form>
  }
  @if (_currentData.currentData && _currentData.currentAction === 'MODIFY') {
    <dhs-form
      [action]="_currentData.currentAction" [fieldGroup]="_currentData.currentFormFields"
      [config]="_currentData.configForm" [data]="_currentData.currentData" (saveFinished)="onSaveFinished($event)"
      [decorator]="_currentData.decorator" [customButton]="_currentData.customButton" #formComponenet>
    </dhs-form>
  }
  @if (_currentData.currentData && _currentData.currentAction === 'VIEW') {
    <dhs-form-view
      [fieldGroup]="_currentData.currentFormFields" [data]="_currentData.currentData">
    </dhs-form-view>
  }
</div>
@if (_currentData.dataList != null && _currentData.showView && callGRID && setData) {
  <div>
    @if (_currentData.currentAction === 'LIST' || _currentData.currentAction === 'VIEW_DETAILS') {
      <dhs-data-grid #datagrid
        [fields]="_currentData.currentListFields" [cardHeaders]="_currentData.cardHeader"
        [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="_currentData.dataList"
        [bulkActionsConfig]="_currentData.bulkAction" [rowClick]="_currentData.rowClick"
        (configValues)="getConfigValues($event)" (bulkActionClicked)="onBulkActionClicked($event)"
        (bindGrid)="bindDataToGrid($event)" (onLimitChange)="limitChanged($event)"
        (onFilterChange)="filterChange($event)" (editEllipseClick)="buttonAction($event)"
        (onPageChanges)="pageChanges($event)" (onSortChanges)="sortChanges($event);"
        [config]="_currentData.dataGridConfig" (gridPopupClicked)="gridPopupApi()">
      </dhs-data-grid>
    }
    <!-- <app-summary-engine
    *ngIf="_currentData.amountData != undefined && _currentData.amountCall && _currentData.amountType == undefined"
    [_summaryData]="_currentData.amountData"
    (summaryResponse)="getSummaryResponse($event)">
  </app-summary-engine> -->
  @if (_currentData.amountData != undefined && _currentData.amountCall && _currentData.amountType == undefined && !_currentData.dynamic_keys) {
    <div
      class="table-summary">
      @for (amount of _currentData.amountData | orderBy:'order'; track amount) {
        <div [ngStyle]="applyStyle()">
          {{amount.key |translate | async}}<b>&nbsp;{{amount.value|exponential:amount}} </b>
        </div>
      }
    </div>
  }
  @if (_currentData.amountData != undefined && _currentData.amountCall && _currentData.amountType == undefined && _currentData.dynamic_keys) {
    <div
      class="table-summary">
      <!-- {{_currentData.amountData | json}} -->
      @for (amount of _currentData.amountData | orderBy:'order'; track amount) {
        <div [ngStyle]="applyStyle()">
          {{amount.key}}<b>&nbsp;{{amount.value|exponential:amount}} </b>
        </div>
      }
    </div>
  }
  @if (_currentData.amountData != undefined && _currentData.amountCall && _currentData.amountType == 'key_value') {
    <div
      class="table-summary">
      <!-- {{_currentData.amountData | json}} -->
      @for (amount of _currentData.amountData | orderBy:'order'; track amount) {
        <div [ngStyle]="applyStyle()">
          {{amount.key}}<b>&nbsp;{{amount.value|exponential:amount}} </b>
        </div>
      }
    </div>
  }
  <!-- <ng-container
  *ngIf="_currentData.amountData != undefined && _currentData.amountCall && _currentData.amountType == 'multiple'">
  <div class="table-summary" *ngFor="let amount of _currentData.amountData ">
    <div><b>{{amount[headerKey]}}</b></div>
    <div *ngFor="let am of amount[mapKey] | keyvalue | orderBy:'order'">{{am.key}}<b>&nbsp;{{am.value |exponential:am}} </b></div>
  </div>
</ng-container> -->
@if (_currentData.amountData != undefined && _currentData.amountCall && (_currentData.amountType == 'multiple_array' || _currentData.amountType == 'multiple')) {
  @for (amount of _currentData.amountData; track amount) {
    <div class="table-summary">
      <div><b>{{amount[headerKey]}}</b></div>
      @for (am of amount[mapKey] | orderBy:'order'; track am) {
        <div>{{am.key}}<b>&nbsp;{{am.value|exponential:am}} </b></div>
      }
    </div>
  }
}
<!-- For viewing of summary -->
@if (_currentData!=undefined && _currentData.resouceDef!=undefined &&_currentData.resouceDef.list!=undefined &&_currentData.resouceDef.list!=undefined && _currentData.resouceDef.list.amountResource!=undefined && _currentData.resouceDef.list.amountResource.datasource!=undefined && _currentData.amountCall!=undefined && !_currentData.amountCall && _currentData.dataList!=undefined && _currentData.dataList.resource!=undefined && _currentData.dataList.resource.length!=undefined && _currentData.dataList.resource.length>0 && !_currentData['hideViewSummary']) {
  <button
  type="button" (click)="getAmountInfo()" class="primary-btn ml-2 _summary-button">View Summary</button>
}
@if (_currentData.amountDatasource != undefined && _currentData.amountCall && _currentData.amountDatasource.resource && _currentData.amountDatasource.resource.length > 0 && _currentData.amountType == 'table') {
  <div
    class="summary-table-container">
    <!-- <dhs-data-grid
    [fields]="_currentData.amountFields" [data]="_currentData.amountDatasource" [config]="{'hideSearchBox': true, 'customButtonsAllowed': false}">
  </dhs-data-grid> -->
  <div class="summary-table">
    <div class="col-12 table-container">
      <div class="table-responsive">
        <table class="base-table">
          <thead>
            <tr>
              @for (field of _currentData.amountFields; track field) {
                <th scope="col">{{field.heading | translate | async}}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (value of _currentData.amountDatasource.resource; track value; let i = $index) {
              <tr>
                @for (field of _currentData.amountFields; track field) {
                  <td>{{value[field.name]|exponential:field}}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
}
</div>
}

<ng-template #customComponent>
</ng-template>
</ng-template>

<div dhs-modal></div>